import React from "react";
import Header from "../components/Header";
 

const Favori=()=>{
    return(
        <div>
            <Header />
            favori listem
        </div>
    )
}



export default Favori;